export default "__VITE_ASSET__CSgLDgJU__"